import { v4 as uuid } from "uuid";

const PLAYER_ID_KEY = "playerId";
const LEGACY_KEY = "userId";

export function getPlayerId() {
  const storedPlayerId = localStorage.getItem(PLAYER_ID_KEY);
  if (storedPlayerId) return storedPlayerId;
  
  const legacyPlayerId = localStorage.getItem(LEGACY_KEY);
  if (legacyPlayerId) {
    localStorage.setItem(PLAYER_ID_KEY, legacyPlayerId);
    return legacyPlayerId;
  }

  const newPlayerId = uuid();
  localStorage.setItem(PLAYER_ID_KEY, newPlayerId);
  return newPlayerId;
}
